export default __webpack_public_path__ + "static/media/14KYCDetailsTataNeu2@3x.7d067bd8.png";